/* Grill Master theme – storefront behaviour (no dependencies) */
(() => {
  const theme = window.gmTheme || { routes: {}, strings: {}, cartType: 'drawer' };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const routeRoot = (theme.routes.root || '/').replace(/\/$/, '');

  /* ---------------- Drawers ---------------- */
  let lastFocus = null;
  const focusable = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    lastFocus = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gm-lock');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const first = $(`.gm-drawer__panel ${focusable}`, drawer);
    if (first) setTimeout(() => first.focus(), 50);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('.gm-drawer.is-open')) document.documentElement.classList.remove('gm-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.drawerOpen), opener);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer(closer.closest('.gm-drawer'));
      return;
    }
    const cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && theme.cartType === 'drawer' && $('#gm-cart-drawer')) {
      e.preventDefault();
      openDrawer($('#gm-cart-drawer'), cartToggle);
    }
  });

  document.addEventListener('keydown', (e) => {
    const open = $('.gm-drawer.is-open');
    if (!open) return;
    if (e.key === 'Escape') closeDrawer(open);
    if (e.key === 'Tab') {
      const items = $$(`.gm-drawer__panel ${focusable}`, open).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });


  /* ---------------- Mega menu ---------------- */
  $$('[data-mega]').forEach((item) => {
    const link = $('.gm-navitem__link', item);
    const set = (open) => { item.classList.toggle('is-open', open); link.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    item.addEventListener('mouseenter', () => set(true));
    item.addEventListener('mouseleave', () => set(false));
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) set(false); });
    link.addEventListener('click', (e) => {
      /* Touch screens: first tap opens the panel, second tap follows the link */
      if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) { e.preventDefault(); set(true); }
    });
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); link.focus(); } });
  });


  /* ---------------- Customer videos ---------------- */
  function initUgc(root = document) {
    const videos = $$('[data-ugc] video', root);
    if (!videos.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    videos.forEach((v) => { v.muted = true; v.setAttribute('playsinline', ''); });
    if (!reduce && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          const v = en.target;
          if (en.isIntersecting) { v.preload = 'auto'; const p = v.play(); if (p && p.catch) p.catch(() => {}); }
          else v.pause();
        });
      }, { threshold: 0.6 });
      videos.forEach((v) => io.observe(v));
    }
    $$('[data-ugc-sound]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const v = $('video', btn.closest('figure'));
        if (!v) return;
        const turnOn = v.muted;
        videos.forEach((o) => { if (o !== v) { o.muted = true; const b = $('[data-ugc-sound]', o.closest('figure')); if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', b.dataset.labelOn); } } });
        v.muted = !turnOn;
        if (turnOn) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
        btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
        btn.setAttribute('aria-label', turnOn ? btn.dataset.labelOff : btn.dataset.labelOn);
      });
    });
  }
  initUgc();
  document.addEventListener('shopify:section:load', (e) => initUgc(e.target));

  /* ---------------- Cart ---------------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
  }

  function renderDrawer(html) {
    const wrapper = $('#shopify-section-cart-drawer');
    if (!wrapper || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#gm-cart-drawer .gm-drawer__panel');
    const current = $('#gm-cart-drawer .gm-drawer__panel');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      if (fresh.dataset.count !== undefined) updateCount(fresh.dataset.count);
    }
    document.dispatchEvent(new CustomEvent('gm:cart-updated'));
  }

  async function refreshCount() {
    try {
      const res = await fetch(`${routeRoot}/cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      updateCount(cart.item_count);
    } catch (err) { /* ignore */ }
  }

  async function addToCart(form) {
    const button = $('button[type="submit"]', form) || $(`button[form="${form.id}"]`);
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    const drawer = $('#gm-cart-drawer');
    const useDrawer = theme.cartType !== 'page' && drawer;
    /* Open the drawer straight away; the new contents slide in when the server answers */
    if (useDrawer) {
      drawer.classList.add('is-loading');
      if (!drawer.classList.contains('is-open')) openDrawer(drawer, button);
    }
    try {
      const res = await fetch(`${routeRoot}/cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.error);
      if (!useDrawer) { window.location.href = theme.routes.cart; return; }
      if (data.sections && data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
      else refreshCount();
    } catch (err) {
      if (useDrawer) closeDrawer(drawer);
      alertMessage(form, err.message || theme.strings.error);
    } finally {
      if (drawer) drawer.classList.remove('is-loading');
      if (button) { button.removeAttribute('aria-busy'); button.disabled = false; }
    }
  }

  function alertMessage(form, msg) {
    let el = $('.gm-formmsg', form);
    if (!el) {
      el = document.createElement('p');
      el.className = 'gm-formmsg';
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    el.textContent = msg;
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-gm-add]');
    if (!form) return;
    if (!window.fetch) return;
    e.preventDefault();
    addToCart(form);
  });

  async function changeLine(line, quantity) {
    const inPage = !!$('[data-cart-page]');
    try {
      const res = await fetch(`${routeRoot}/cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)), sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || theme.strings.error);
      if (inPage) { window.location.reload(); return; }
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      updateCount(data.item_count);
    } catch (err) {
      window.alert(err.message || theme.strings.error);
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (btn) {
      e.preventDefault();
      changeLine(btn.dataset.qtyChange, btn.dataset.qty);
    }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('input[type="number"]', step.parentElement);
      const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(step.dataset.qtyStep));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', (e) => {
    const qtyInput = e.target.closest('[data-qty-input]');
    if (qtyInput) changeLine(qtyInput.dataset.qtyInput, qtyInput.value);
    const auto = e.target.closest('[data-autosubmit]');
    if (auto && auto.form) auto.form.submit();
  });

  /* ---------------- Variant picker ---------------- */
  $$('[data-product-section]').forEach((sectionEl) => {
    const dataEl = $('[data-variants]', sectionEl);
    const picker = $('[data-variant-picker]', sectionEl);
    if (!dataEl || !picker) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('[data-variant-id]', sectionEl);
    const priceEl = $('[data-price] .gm-h', sectionEl);
    const addBtn = $('[data-add-button]', sectionEl);
    const stickyPrice = $('[data-sticky-price]');
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);

    picker.addEventListener('change', () => {
      const selected = $$('fieldset', picker).map((fs) => { const r = $('input:checked', fs); return r ? r.value : null; });
      const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = theme.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.innerHTML = variant.available ? `${theme.strings.addToCart}<span class="gm-atc-price">&nbsp;· ${money(variant.price)}</span>` : theme.strings.soldOut;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media) {
        const media = $(`[data-media-id="${variant.featured_media.id}"]`, sectionEl);
        const gal = $('[data-gallery]', sectionEl);
        if (media && gal) gal.scrollTo({ left: media.offsetLeft - gal.offsetLeft - 16, behavior: 'smooth' });
      }
    });
  });

  /* ---------------- Recommendations ---------------- */
  async function fetchSection(url) {
    const res = await fetch(url);
    if (!res.ok) throw new Error('fail');
    return new DOMParser().parseFromString(await res.text(), 'text/html');
  }

  $$('[data-complementary]').forEach(async (el) => {
    /* Complementary products first; none set up? fall back to related products */
    const urls = [el.dataset.complementary, el.dataset.complementary.replace('intent=complementary', 'intent=related')];
    for (const url of urls) {
      try {
        const doc = await fetchSection(url);
        const fresh = doc.querySelector('[data-complementary]');
        if (fresh && fresh.querySelector('.gm-together__item')) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          return;
        }
      } catch (err) { /* try next */ }
    }
  });

  $$('[data-recommendations]').forEach(async (el) => {
    if (el.querySelector('.gm-card')) return;
    try {
      const doc = await fetchSection(el.dataset.recommendations);
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initRails(el); }
      else el.closest('.shopify-section')?.setAttribute('hidden', '');
    } catch (err) { /* ignore */ }
  });

  /* ---------------- Rails & gallery ---------------- */
  function initRails(root = document) {
    $$('[data-rail]', root).forEach((rail) => {
      if (rail.dataset.railInit) return;
      rail.dataset.railInit = '1';
      const container = rail.parentElement;
      const bar = $('[data-rail-bar] span', container);
      const arrows = $$('.gm-arrows', rail.closest('section') || container);
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        arrows.forEach((a) => { a.style.visibility = max > 4 ? '' : 'hidden'; });
        if (!bar) return;
        const ratio = rail.clientWidth / rail.scrollWidth;
        bar.style.width = `${Math.max(ratio * 100, 12)}%`;
        const progress = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.transform = `translateX(${progress * ((1 / Math.max(ratio, 0.12)) - 1) * 100}%)`;
        bar.parentElement.style.visibility = max > 4 ? 'visible' : 'hidden';
      };
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      const section = rail.closest('section') || container;
      const step = () => (rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 16 : 300);
      const go = (dir) => {
        const start = rail.scrollLeft;
        const target = Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, start + dir * step()));
        if (Math.abs(target - start) < 2) return;
        rail.scrollTo({ left: target, behavior: 'smooth' });
        /* Some browsers ignore smooth scrolling on snap containers: jump instead */
        setTimeout(() => { if (Math.abs(rail.scrollLeft - start) < 2) rail.scrollLeft = target; }, 450);
      };
      $$('[data-rail-prev]', section).forEach((b) => b.addEventListener('click', () => go(-1)));
      $$('[data-rail-next]', section).forEach((b) => b.addEventListener('click', () => go(1)));
    });
  }
  initRails();

  $$('[data-gallery]').forEach((gal) => {
    const dots = $$('[data-gallery-dots] span', gal.closest('[data-product-section]') || document);
    if (!dots.length) return;
    gal.addEventListener('scroll', () => {
      const items = Array.from(gal.children);
      const center = gal.scrollLeft + gal.clientWidth / 2;
      let idx = 0;
      items.forEach((it, i) => { if (it.offsetLeft - gal.offsetLeft <= center) idx = i; });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }, { passive: true });
  });

  /* ---------------- Sticky add to cart (mobile) ---------------- */
  const sticky = $('[data-sticky-atc]');
  const mainForm = $('[data-main-form]');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button', sticky).forEach((b) => { b.tabIndex = show ? 0 : -1; });
    }).observe(mainForm);
  }

  /* ---------------- Read more (SEO text) ---------------- */
  $$('[data-seo-toggle]').forEach((btn) => {
    const text = document.getElementById(btn.getAttribute('aria-controls'));
    if (!text) return;
    if (text.scrollHeight <= text.clientHeight + 4) { btn.hidden = true; return; }
    const more = btn.textContent;
    btn.addEventListener('click', () => {
      const open = text.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : more;
    });
  });

  /* ---------------- Cart upsell fallback (complementary products) ---------------- */
  const fmtMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);

  async function initUpsell(root = document) {
    const box = $('[data-cart-upsell]', root);
    if (!box || !box.hidden || !box.dataset.productId) return;
    try {
      const max = Number(box.dataset.max || 2);
      const exclude = box.dataset.exclude || '';
      const url = `${theme.routes.recommendations}.json?product_id=${box.dataset.productId}&limit=6&intent=complementary`;
      const res = await fetch(url);
      if (!res.ok) return;
      const data = await res.json();
      const list = $('[data-upsell-list]', box);
      const products = (data.products || []).filter((p) => p.available && !exclude.includes(`|${p.handle}|`)).slice(0, max);
      if (!products.length || !list) return;
      list.innerHTML = products.map((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        const img = p.featured_image ? `<img src="${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=160" alt="" loading="lazy">` : '';
        const single = p.variants.length === 1;
        const action = single
          ? `<form method="post" action="${theme.routes.cartAdd}" data-gm-add><input type="hidden" name="id" value="${v.id}"><button type="submit" class="gm-btn gm-btn--dark gm-btn--small">+ ${theme.strings.add || '+'}</button></form>`
          : `<a href="${p.url}" class="gm-btn gm-btn--dark gm-btn--small">${theme.strings.choose || '→'}</a>`;
        return `<div class="gm-together__item"><a href="${p.url}" class="gm-together__img">${img}</a><div style="flex:1;min-width:0"><a href="${p.url}" style="font-weight:600;font-size:13px;text-decoration:none">${p.title}</a><div class="gm-small gm-muted">${fmtMoney(v.price)}</div></div>${action}</div>`;
      }).join('');
      box.hidden = false;
    } catch (err) { /* ignore */ }
  }
  initUpsell();
  document.addEventListener('gm:cart-updated', () => initUpsell($('#gm-cart-drawer')));

  /* ---------------- Theme editor support ---------------- */
  document.addEventListener('shopify:section:load', (e) => initRails(e.target));
})();
